@let data = dialogData();

<dashboard-dialog-frame header='Add Specialist Sign-up' [dialogRef]='dialogRef' [actions]="actions()">

	<div class="p-3">
		<person-finder-widget searchLabel='Search Person' (selectedRowId)="setSelectedPersonId($event)"></person-finder-widget>

		@if(specialistAvailability(); as specialist) {
		<div class="mt-4 mb-3">
			@if(!specialist.volunteerId) {
			<p class="text-danger">Selected person does not have a Volunteer record</p>

			} @else if(specialist.approvalIssues; as approvalIssues) {
			<p class="text-danger mb-2">Selected person is not in a valid status. Please update their Volunteer details for the following to continue:</p>
			<ul class="text-danger">
				@if(!approvalIssues.isVolunteerApproved) {
				<li>Volunteer record must be marked "Approved"</li>
				}
				@if(!approvalIssues.isVolunteerInClassApproved) {
				<li>Must be In-Class Specialist Approved</li>
				}
				@if(!approvalIssues.isApprovedForTopic){
				<li>Must be Approved for {{data?.topicName}}</li>
				}
				@if(!approvalIssues.isApprovedForLanguage){
				<li>Must be Approved for {{data?.language}}</li>
				}
			</ul>
			} @else if(specialist.hasExistingLanguageSignUpForTopic) {
			<p class="text-danger">Already signed up for this session.</p>
			}
			@else if (specialist.volunteerId && !specialist.approvalIssues) {
			<p class="text-success">Looks good! Continue adding Specialist Sign-up?</p>
			}
		</div>
		}
	</div>

</dashboard-dialog-frame>